import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'

const service = axios.create({
  baseURL: '/xunshanke-server',
  timeout: 5000
})

// 是否正在自动重新登录
let isRefreshing = false
// 是否自动登录失败过（失败后不再尝试）
let loginFailed = false
// 存储需要重试的请求
let requests = []

// 自动登录函数
async function autoLogin() {
  const savedLoginInfo = localStorage.getItem('loginInfo')
  if (!savedLoginInfo) {
    return false
  }

  try {
    const loginInfo = JSON.parse(savedLoginInfo)
    // 检查是否过期（7天有效期）
    const now = Date.now()
    const expireTime = loginInfo.expireTime || 0
    if (now > expireTime) {
      localStorage.removeItem('loginInfo')
      return false
    }

    // 调用登录接口（与登录页相同的方式）
    // 创建 FormData 格式的数据（与 service 拦截器处理一致）
    const formData = new FormData()
    formData.append('mobile', loginInfo.mobile)
    formData.append('password', loginInfo.password)

    const response = await axios.post(
      '/xunshanke-server/admin/adminLogin.do',
      formData
    )

    const res = response.data
    if (res.code === '0' || res.code === 0) {
      // 登录成功，保存token
      const tokenValue = res.object?.tokenValue || ''
      if (tokenValue) {
        localStorage.setItem('token', tokenValue)
        // 更新过期时间（30天）
        const thirtyDays = 30 * 24 * 60 * 60 * 1000
        localStorage.setItem(
          'loginInfo',
          JSON.stringify({
            mobile: loginInfo.mobile,
            password: loginInfo.password,
            expireTime: Date.now() + thirtyDays
          })
        )
        return true
      }
    }
  } catch (error) {
    console.error('自动登录失败', error)
  }
  return false
}

service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = token
    }

    // 统一处理 POST 请求的参数 - 使用 FormData 格式（与 Postman 一致）
    // 注意：如果 data 已经是 FormData（如文件上传），则不需要处理
    if (
      config.method === 'post' &&
      config.data &&
      typeof config.data === 'object' &&
      !(config.data instanceof FormData)
    ) {
      const formData = new FormData()
      Object.keys(config.data).forEach((key) => {
        formData.append(key, config.data[key])
      })
      config.data = formData
      // 不要手动设置 Content-Type，让浏览器自动设置 multipart/form-data 和 boundary
      delete config.headers['Content-Type']
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    const res = response.data
    // 处理 9999 状态码：Token 过期或无效，尝试自动登录
    if (res.code === '9999' || res.code === 9999) {
      // 清除本地 token
      localStorage.removeItem('token')

      return new Promise((resolve, reject) => {
        if (!isRefreshing && !loginFailed) {
          isRefreshing = true
          // 尝试自动登录
          autoLogin().then((success) => {
            isRefreshing = false
            if (success) {
              // 重新保存需要重试的请求
              requests.forEach((cb) => cb())
              requests = []
              // 重新发起当前请求
              const config = response.config
              const token = localStorage.getItem('token')
              if (token) {
                config.headers['Authorization'] = token
              }
              service(config).then(resolve).catch(reject)
            } else {
              // 自动登录失败，标记状态，跳转到登录页
              loginFailed = true
              import('element-ui').then((Element) => {
                Element.Message({
                  message: res.message || '登录状态已过期，请重新登录',
                  type: 'error',
                  duration: 3000
                })
              })
              window.location.href = '/#/login'
              reject(new Error(res.message || '9999'))
            }
          })
        } else if (loginFailed) {
          // 已经失败过，直接跳转到登录页
          window.location.href = '/#/login'
          reject(new Error(res.message || '9999'))
        } else {
          // 正在刷新token，将请求加入队列
          requests.push(() => {
            const config = response.config
            const token = localStorage.getItem('token')
            if (token) {
              config.headers['Authorization'] = token
            }
            service(config).then(resolve).catch(reject)
          })
        }
      })
    }

    // API返回code: "0"表示成功，其他表示失败
    if (res.code !== '0' && res.code !== 0) {
      return Promise.reject(new Error(res.message || 'Error'))
    }
    return res
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default service
